import { Module } from 'vuex';

import { Nullable, RootState } from 'frontend/types';

export type SignupModalView = 'signup' | 'login' | 'signup-form' | 'login-form';
type NextUrl = Nullable<string>;

interface SignupModalState {
  signupModalIsVisible: boolean;
  currentView: SignupModalView;
  nextUrl: NextUrl;
}

const signupModal: Module<SignupModalState, RootState> = {
  namespaced: true,
  state: () => ({
    signupModalIsVisible: false,
    currentView: 'signup',
    nextUrl: null,
  }),
  mutations: {
    setValue(state: SignupModalState, value: SignupModalState) {
      Object.assign(state, value);
    },
    setView(state: SignupModalState, view: SignupModalView) {
      state.currentView = view;
    },
  },
  actions: {
    signup({ commit }, nextUrl: NextUrl = null) {
      const newState: SignupModalState = {
        nextUrl,
        signupModalIsVisible: true,
        currentView: 'signup',
      };
      commit('setValue', newState);
    },
    login({ commit }, nextUrl: NextUrl = null) {
      const newState: SignupModalState = {
        nextUrl,
        signupModalIsVisible: true,
        currentView: 'login',
      };
      commit('setValue', newState);
    },
    switchView({ commit }, view: SignupModalView) {
      commit('setView', view);
    },
    hide({ commit, state }) {
      // The view doesn't really matter; it will be reset the next time the modal is opened
      const currentView: SignupModalView = state.currentView;
      const newState: SignupModalState = {
        currentView,
        signupModalIsVisible: false,
        nextUrl: null,
      };
      commit('setValue', newState);
    },
  },
};

export default signupModal;
